// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgFlask = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 3.25a.75.75 0 0 1 0 1.5h-.25v5.51c0 .298.107.587.3.813l5.038 5.877a2.75 2.75 0 0 1 .662 1.79V19A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19v-.26c0-.656.235-1.292.662-1.79l5.037-5.877a1.25 1.25 0 0 0 .301-.814V4.75H8a.75.75 0 0 1 0-1.5zM4.05 17.927c-.193.226-.3.515-.3.813V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-.26c0-.298-.107-.587-.3-.813l-1.866-2.177H5.916l-1.865 2.177Zm5.7-7.668a2.75 2.75 0 0 1-.662 1.79l-1.886 2.2h9.596l-1.886-2.2a2.75 2.75 0 0 1-.662-1.79V4.75h-4.5zm1.702-1.762A.75.75 0 0 1 12.567 9.5l-.01.01a.75.75 0 0 1-1.115-1.003zm-1-7A.75.75 0 0 1 11.567 2.5l-.01.01a.75.75 0 0 1-1.115-1.003l.01-.011Z"
    />
  </svg>
);
export const FlaskIcon = forwardRef(SvgFlask);
